import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import clientReducer from './slices/client';
import commonReducer from './slices/common';
import companyReducer from './slices/company';
import customerReducer from './slices/customer';
import fosterFamilyReducer from './slices/fosterFamily';
import placementReducer from './slices/placement';
import userReducer from './slices/user';

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  keyPrefix: 'redux-',
  storage,
  whitelist: [],
};

const rootReducer = combineReducers({
  client: clientReducer,
  common: commonReducer,
  company: companyReducer,
  customer: customerReducer,
  fosterFamily: fosterFamilyReducer,
  placement: placementReducer,
  user: userReducer,
});

export default rootReducer;
